import React from 'react';

import { flagStyles } from '../settings';

const SvgHT = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2328px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgHT;
